import React, { useContext, useState } from "react";
import List from '../../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import moment from "moment-timezone"
import ToolBar from "../../../../Common/Toolbar";
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListLastActions } from "../../../../../hooks/services/sKPI/useOfGAP";
import { __OBJECT_STRUCTURE_GetList } from "../../../../../common/ObjectStructures/Trasnversal";
import CLabel from "../../../../Common/CLabel";
import NoDataLayer from "../../../../Common/NoDataLayer";
import './style.css'
import { ScrollablePane, ScrollbarVisibility } from "@fluentui/react";
import PropTypes from 'prop-types';
import { useManageLastActionBox } from "../../../../../hooks/component/sKPI/useOfMessageLastActions";
import GapAppContext from "../../../../../GapAppContext";

function MessageLastActionsBox(props) {
    const { t } = useTranslation();
    const contextGap = useContext(GapAppContext);

    //Parametros de entrada.
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_CalledFromHome = false,
    } = props;

    //Parametros de componente.
    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList(2));
    const [numberOfItems, setNumberOfItems] = useState(messageEventList.pageSize);
    const [messageDataLength, setMessageDataLength] = useState(2);
    useGetListLastActions(inputParam_GapAnalyzeId, messageEventList, setMessageEventList, null, setNumberOfItems);
    const onGetMoreData = () => {
        if (!inputParam_CalledFromHome) {
            contextGap.dataserieFullData.set(prevState => ({
                ...prevState,
                revisionDataserieFullList: contextGap.dataserieFullData.value.revisionDataserieFullList,
                fireUpdateLastAction: true
            }));
        }

        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 2,
                totalPages:  (messageEventList.data.length + 2) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length + 2)
        }
    }
 
    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <Card className={`${inputParam_CalledFromHome ? 'h-100': 'h-100'}`}>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-lbl-lastactions')}</b>
                    <div className='toolbar'>
                        <ToolBar items={ toolBarItems_Communication } styles={{root: {height: "30px"}}} display={ displayToolBarCommunication } />
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body id="listLastAcctionsGAP" className="overflow-auto h-100">
                <Row>
                    {
                        messageEventList.data !== null &&
                        <ScrollablePane
                            style={{minHeight: "320px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            <List
                                manipulateLocalData={ true }
                                className="no-compact-list"
                                showHeaders={ false }
                                isHeaderVisible={ false }
                                listLocalStoragePageSizeVariableName="lastGapActions"
                                data={ (messageEventList) }
                                setData={ setMessageEventList }
                                columns={ [
                                {
                                    key: 'all-props-all-props',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'all-props-all-props',
                                    onRender:(item) => {
                                        const html = <Row>
                                                        <div className="text-end position-absolute">{ moment(item.beginDate).format("DD/MM/YYYY") }</div>
                                                        <Col title={item.action} xl={12}><CLabel labelText={t('data-lang-lbl-title')} labelValue={item.title} /></Col>
                                                        {
                                                            item.gapActionParentName && 
                                                            <Col xl={12}><CLabel labelText={t('data-lang-lbl-variablename')} labelValue={item.gapActionParentName} /></Col>
                                                        }
                                                        <Col xl={12}>
                                                            <Row>
                                                                <Col>
                                                                    <CLabel labelText={t('data-lang-lbl-responsible')} labelValue={item.owner} />
                                                                </Col>
                                                                <Col>
                                                                    <CLabel labelText={t('data-lang-lbl-executor')} labelValue={item.executor} />
                                                                </Col>
                                                                <Col className="col-auto"><CLabel labelText={t('data-lang-lbl-status')} labelValue={t(`data-lang-skaction-status${item.statusId}`)} /></Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                        
                                        return  html;
                                    }
                                }] }
                            />   
                        </ScrollablePane >
                    }  
                    <NoDataLayer display={messageEventList.data === null} text={t('data-lang-msg-selectgap')} />                   
                </Row>
            </Card.Body>
            <Card.Footer>
                <ListPagination
                    listLocalStoragePageSizeVariableName="lastGapActions"
                    data={ (messageEventList !== null ? messageEventList : []) }
                    setData={ setMessageEventList } />
            </Card.Footer>
        </Card>
    );
}

///Proptypes
MessageLastActionsBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_CalledFromHome: PropTypes.bool.isRequired,
};

export default MessageLastActionsBox;

